"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getItems(objectType) {
    return (rootState) => {
        const workspaceId = rootState.workspaces.activeWorkspaceId;
        if (!rootState.entities.items.has(`${workspaceId}:${objectType}`)) {
            return [];
        }
        return rootState.entities.items
            .get(`${workspaceId}:${objectType}`)
            .map((itemId) => rootState.entities.entitiesById.get(`${workspaceId}:${objectType}:${itemId}`));
    };
}
exports.getItems = getItems;
function getItemById(objectType, itemId) {
    return (rootState) => {
        const workspaceId = rootState.workspaces.activeWorkspaceId;
        if (!rootState.entities.entitiesById.has(`${workspaceId}:${objectType}:${itemId}`)) {
            return;
        }
        return rootState.entities.entitiesById.get(`${workspaceId}:${objectType}:${itemId}`);
    };
}
exports.getItemById = getItemById;
function state(objectType) {
    return (rootState) => {
        const errorMessage = rootState.entities.errorMessage.has(objectType)
            ? rootState.entities.errorMessage.get(objectType)
            : null;
        const isProcessing = rootState.entities.isProcessing.has(objectType)
            ? rootState.entities.isProcessing.get(objectType)
            : false;
        const itemErrorMessage = rootState.entities.errorMessage.has(`${objectType}:item`)
            ? rootState.entities.errorMessage.get(`${objectType}:item`)
            : null;
        const isItemProcessing = rootState.entities.isProcessing.has(`${objectType}:item`)
            ? rootState.entities.isProcessing.get(`${objectType}:item`)
            : false;
        return { errorMessage, itemErrorMessage, isProcessing, isItemProcessing };
    };
}
exports.state = state;
function stateByItemId(objectType, objectId) {
    return (rootState) => {
        const errorMessage = rootState.entities.errorMessage.has(`${objectType}:${objectId}`)
            ? rootState.entities.errorMessage.get(`${objectType}:${objectId}`)
            : null;
        const isProcessing = rootState.entities.isProcessing.has(`${objectType}:${objectId}`)
            ? rootState.entities.isProcessing.get(`${objectType}:${objectId}`)
            : false;
        return { errorMessage, isProcessing };
    };
}
exports.stateByItemId = stateByItemId;
//# sourceMappingURL=selectors.js.map